import { render } from "./Policyform.vue?vue&type=template&id=77ed0486"
import script from "./Policyform.vue?vue&type=script&lang=js"
export * from "./Policyform.vue?vue&type=script&lang=js"

import "./Policyform.vue?vue&type=style&index=0&id=77ed0486&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__